// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/style/index.less
 ** module id = 4
 ** module chunks = 0
 **/